import React, { useEffect, useRef } from "react";
import transition from "./transition";

import a1 from "../assets/a1.jpg";
import a2 from "../assets/a2.jpg";
import a3 from "../assets/a3.jpg";
import a4 from "../assets/a4.jpg";
import a5 from "../assets/a5.jpg";
import a6 from "../assets/a6.jpg";
import a7 from "../assets/a7.jpg";
import a8 from "../assets/a8.jpg";
import a9 from "../assets/a9.jpg";
import a10 from "../assets/a10.JPG";

import "../style/About.css";

const About = () => {
    const sectionRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0.2,
        };

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("visible");
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        sectionRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            sectionRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    const addToRefs = (el, index) => {
        if (el) {
            setTimeout(() => {
                el.style.opacity = "1";
            }, index * 200); // Delay for effect
        }
    };

    return (
        <div className="about-container">
            <div className="about-page">
                {/* Hero Section */}
                <section className="hero-section">
                    <div
                        className="hero-content"
                        ref={(el) => addToRefs(el, 0)}
                    >
                        <h1 className="hero-title">
                            Joshua Smith
                        </h1>
                        <div className="hero-description-container">
                            <div className="divider"></div>
                            <p className="hero-description">
                                Dancer Boy Smith — reshaping an evolving industry.
                            </p>
                            <div className="divider"></div>
                        </div>
                    </div>
                </section>

                {/* First Section - Image Right */}
                <section className="section">
                    <div
                        className="section-content"
                        ref={(el) => addToRefs(el, 1)}
                    >
                        <div className="text-content left">
                            <h2 className="section-heading">The Visionary</h2>
                            <p className="section-text">
                                His cultivation of highly successful productions as a Visionary, Creative Director and Choreographer,
                                paired with his strong and youthful social media presence, makes Josh one of the most in-demand,
                                and innovative movement artists of this generation.
                            </p>
                            <p className="section-text">
                                Born in the small city of Durham, North Carolina, Josh spent his early industry years as a dancer
                                in Atlanta, Georgia, touring with the likes of Usher and Austin Mahone. Despite great success,
                                at the young age of 23, he quickly transitioned to behind the scenes, for some of the same artists
                                he once toured for and more.
                            </p>
                        </div>
                        <div className="image-container right">
                            <img
                                src= {a5}
                                alt="Joshua Smith on stage with a microphone"
                                className="section-image"
                            />
                        </div>
                    </div>
                </section>

                {/* Second Section - Image Left */}
                <section className="section">
                    <div
                        className="section-content"
                        ref={(el) => addToRefs(el, 2)}
                    >
                        <div className="image-container left">
                            <img
                                src={a6}
                                alt="Dancers on stage with Joshua Smith directing"
                                className="section-image"
                            />
                        </div>
                        <div className="text-content right">
                            <h2 className="section-heading">Global Influence</h2>
                            <p className="section-text">
                                From choreographing internationally sold out shows for over 100,000 screaming fans, to landing his own moves
                                in virtual worlds like Fortnite, this 2019, Soul Train award-winning choreographer has catapulted his way
                                into almost every artists movement catalog.
                            </p>
                            <p className="section-text">
                                As the exclusive, 8 year running Artistic, Creative and Head Choreographer for the world renown Chris Brown,
                                he has also worked with artists from all sides of the industry: Usher, BTS, Ciara, Jack Harlow, Summer Walker,
                                Gelo Ball, Davido, Pharrell, Lil Nas X, Lil Baby, 21 Savage, Omarion, Kelly Rowland, Neyo, Tinashe, Tee Grizzly
                                and Cassie, amongst many others.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="section">
                    <div
                        className="section-content"
                        ref={(el) => addToRefs(el, 3)}
                    >
                        <div className="text-content left">
                            <h2 className="section-heading">Performance Mastery</h2>
                            <p className="section-text">
                                His work has appeared on stages like The Grammys, VMAs, SNL, Jimmy Fallon, Jimmy Kimmel, Billboard Awards,
                                BET Awards and AMAs.
                            </p>
                            <p className="section-text">
                                During his off time from creating, Josh is seen teaching around the world at both conventions and
                                international workshops, inspiring the masses, and spreading the culture of today. Aside from his many accolades,
                                his main passion will always be to bring purpose and story telling to anything he touches.
                            </p>
                        </div>
                        <div className="image-container right">
                            <img
                                src={a7}
                                alt="Joshua Smith with colleagues backstage"
                                className="section-image"
                            />
                        </div>
                    </div>
                </section>

                {/* Fourth Section - Image Left */}
                <section className="section">
                    <div
                        className="section-content"
                        ref={(el) => addToRefs(el, 4)}
                    >
                        <div className="image-container left">
                            <img
                                src={a8}
                                alt="Joshua Smith smiling"
                                className="section-image"
                            />
                        </div>
                        <div className="text-content right">
                            <h2 className="section-heading">Creative Direction</h2>
                            <p className="section-text" style={{ fontStyle: 'italic' }}>
                                "Creative Direction allows me to dream and shape-shift reality. It is the gateway to giving the audience an
                                experience they'll never forget."
                            </p>
                        </div>
                    </div>

                    {/* Photo Grid Section */}
                    <section className="section">
                        <div className="container">
                            <div
                                ref={(el) => addToRefs(el, 5)}
                            >
                                <h2 className="section-heading" style={{ margin: '0 auto', textAlign: 'center', marginBottom: '48px' }}>
                                    Behind The Scenes
                                </h2>
                                <div className="photo-grid">
                                    <div className="image-container">
                                        <img
                                            src={a9}
                                            alt="Joshua Smith backstage"
                                            className="section-image"
                                        />
                                    </div>
                                    <div className="image-container">
                                        <img
                                            src={a10}
                                            alt="Joshua Smith with hands covering face"
                                            className="section-image"
                                        />
                                    </div>
                                    <div className="image-container">
                                        <img
                                            src={a3}
                                            alt="Joshua Smith in green jacket"
                                            className="section-image"
                                        />
                                    </div>
                                    <div className="image-container">
                                        <img
                                            src={a4}
                                            alt="Joshua Smith in the city"
                                            className="section-image"
                                        />
                                    </div>
                                    <div className="image-container">
                                        <img
                                            src={a1}
                                            alt="Joshua Smith walking on a bridge"
                                            className="section-image"
                                        />
                                    </div>
                                    <div className="image-container">
                                        <img
                                            src={a2}
                                            alt="Joshua Smith sitting on white surface"
                                            className="section-image"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="motto-section">
                        <div
                            className="motto-content"
                            ref={(el) => addToRefs(el, 6)}
                        >
                            <h2 className="motto-title">
                                JOSH'S PHILOSOPHY
                            </h2>
                            <p className="motto-quote">
                                No dream is too Big.
                            </p>
                            <div className="motto-footer">
                                <div className="divider"></div>
                                <p className="motto-subtitle">Creative Director & Choreographer</p>
                                <div className="divider"></div>
                            </div>
                        </div>
                    </section>
                </section>


            </div>

        </div>
    );
};

export default transition(About);
